module.exports = __webpack_public_path__ + "img/Project_validated.80373a54.svg";